/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Col_PermissionsInputs */

const vi_api_keys_col_permissions = /** @type {(inputs: Api_Keys_Col_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quyền truy cập`)
};

/**

* @param {Api_Keys_Col_PermissionsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_col_permissions = /** @type {((inputs?: Api_Keys_Col_PermissionsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Col_PermissionsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_col_permissions(inputs)
});